import { Center, Button } from '@mantine/core';

export default function ConnectMonday() {
  return (
    <Center
      h="100vh"
      bg="var(--mantine-color-gray-light)"
      style={{ boxShadow: 'inset 0 0 10rem #aaa' }}
    >
      <Button
        onClick={() => {
          const searchParams = new URLSearchParams();
          searchParams.set('client_id', import.meta.env.VITE_MONDAY_CLIENT_ID);
          searchParams.set(
            'redirect_uri',
            `${window.location.origin}/api/backoffice/monday/oauth2`,
          );
          window.open(
            `https://auth.monday.com/oauth2/authorize?${searchParams.toString()}`,
            '_self',
          );
        }}
      >
        Connect with Monday
      </Button>
    </Center>
  );
}
